import imovelSmall from "../assets/imovelSmall.png";
import automovelSmall from "../assets/automovelSmall.png";
import tratorSmall from "../assets/tratorSmall.png";
import serviceSmall from "../assets/serviceSmall.png";
import motoSmall from "../assets/motoSmall.png";
import imovelLarge from "../assets/imovel.png";
import automovelLarge from "../assets/automovel.png";
import tratorLarge from "../assets/trator.png";
import serviceLarge from "../assets/service.png";
import motoLarge from "../assets/moto.png";
import imovelMobile from "../assets/imovelMobile.png";
import automovelMobile from "../assets/automovelMobile.png";
import tratorMobile from "../assets/tratorMobile.png";
import serviceMobile from "../assets/serviceMobile.png";
import motoMobile from "../assets/motoMobile.png";
import automovelAutoValorSmall from "../assets/automovelAutoValorSmall.png";
import automovelAutoValor from "../assets/automovelAutoValor.png";
import automovelAutoValorMobile from "../assets/automovelAutoValorMobile.png";
import motoAutoValorSmall from "../assets/motoAutoValorSmall.png";
import motoAutoValor from "../assets/motoAutoValor.png";
import motoAutoValorMobile from "../assets/motoAutoValorMobile.png";

interface IDataForProducts {
  [key: string]: {
    titleCard: string;
    details: {
      value: string;
      imageSmall: string;
      imageLarge: string;
      imageMobile: string;
      listPossibilities: string[];
    };
  };
}

export const dataForProducts: IDataForProducts = {
  1: {
    titleCard: "Automóveis",
    details: {
      value: "De 40 a 180 mil reais",
      imageSmall: automovelSmall,
      imageLarge: automovelLarge,
      imageMobile: automovelMobile,
      listPossibilities: [
        "Motocicletas novas ou seminovas com até 5 anos de fabricação;",
        "Automóveis, SUVs, caminhonetes, caminhões, carretas, tratores e utilitários novos ou seminovos com até 10 anos de fabricação;",
        "Lanchas, embarcações de esporte ou lazer, jets novos ou seminovos com até 10 anos de fabricação;",
        "Máquinas e equipamentos agrícolas tais como: colheitadeiras, pulverizadores, roçadeiras agrícolas, plantadeiras entre outros;",
        "Drones para uso na agricultura, infraestrutura, lazer etc;",
        "Painéis solares e bens sustentáveis tais como: gerador de energia solar ou eólico, equipamentos de tratamento de água e esgoto, aquecedores solares para água entre outros equipamentos ecoeficientes;",
      ],
    },
  },
  2: {
    titleCard: "Motos",
    details: {
      value: "De 10 a 35 mil reais",
      imageSmall: motoSmall,
      imageLarge: motoLarge,
      imageMobile: motoMobile,
      listPossibilities: [
        "Motocicletas novas ou seminovas com até 5 anos de fabricação;",
        "Automóveis, SUVs, caminhonetes, caminhões, carretas, tratores e utilitários novos ou seminovos com até 10 anos de fabricação;",
        "Lanchas, embarcações de esporte ou lazer, jets novos ou seminovos com até 10 anos de fabricação;",
        "Máquinas e equipamentos agrícolas tais como: colheitadeiras, pulverizadores, roçadeiras agrícolas, plantadeiras entre outros;",
        "Drones para uso na agricultura, infraestrutura, lazer etc;",
        "Painéis solares e bens sustentáveis tais como: gerador de energia solar ou eólico, equipamentos de tratamento de água e esgoto, aquecedores solares para água entre outros equipamentos ecoeficientes;",
      ],
    },
  },
  3: {
    titleCard: "Imóveis ",
    details: {
      value: "De 80 a 800 mil reais",
      imageSmall: imovelSmall,
      imageLarge: imovelLarge,
      imageMobile: imovelMobile,
      listPossibilities: [
        "Adquirir Imóveis residenciais ou comerciais novos ou usados;",
        "Construir, reformar ou ampliar;",
        "Quitar um financiamento de sua titularidade;",
      ],
    },
  },
  4: {
    titleCard: "Veículos pesados",
    details: {
      value: "De 200 a 800 mil reais",
      imageSmall: tratorSmall,
      imageLarge: tratorLarge,
      imageMobile: tratorMobile,
      listPossibilities: [
        "Motocicletas novas ou seminovas com até 5 anos de fabricação;",
        "Automóveis, SUVs, caminhonetes, caminhões, carretas, tratores e utilitários novos ou seminovos com até 10 anos de fabricação;",
        "Lanchas, embarcações de esporte ou lazer, jets novos ou seminovos com até 10 anos de fabricação;",
        "Máquinas e equipamentos agrícolas tais como: colheitadeiras, pulverizadores, roçadeiras agrícolas, plantadeiras entre outros;",
        "Drones para uso na agricultura, infraestrutura, lazer etc;",
        "Painéis solares e bens sustentáveis tais como: gerador de energia solar ou eólico, equipamentos de tratamento de água e esgoto, aquecedores solares para água entre outros equipamentos ecoeficientes;",
      ],
    },
  },
  5: {
    titleCard: "Serviços",
    details: {
      value: "De 5 a 40 mil reais",
      imageSmall: serviceSmall,
      imageLarge: serviceLarge,
      imageMobile: serviceMobile,
      listPossibilities: [
        "Adquirir pacotes de viagens;",
        "Serviços para organização de festas de casamentos, formaturas, aniversários, entre outras;",
        "Realização de cirurgias estéticas e procedimentos médicos ou cursos técnico, superior, de especialização, MBA, idiomas, informática, entre outros;",
        "Serviço de consultoria, assessoria jurídica, contábil, tributária, treinamentos, entre outras;",
        "Projetos e serviços (mão de obra) de pequenas reformas;",
      ],
    },
  },
};

export interface IProductVisual {
  imageSmall: string;
  imageLarge: string;
  imageMobile: string;
  value: string;
  listPossibilities: string[];
}

/**
 * A API /product (v2) já retorna title/text prontos por produto (mesmo padrão do app iOS),
 * então aqui mantemos apenas as imagens/faixa de valor/possibilidades locais, agrupadas por
 * "família" de produto e associadas ao idComercial (único por item, ao contrário de
 * idProduto/idSubProduto que podem se repetir entre produtos diferentes).
 */
const visualByFamily = {
  automovel: {
    imageSmall: automovelSmall,
    imageLarge: automovelLarge,
    imageMobile: automovelMobile,
    value: dataForProducts[1].details.value,
    listPossibilities: dataForProducts[1].details.listPossibilities,
  },
  moto: {
    imageSmall: motoSmall,
    imageLarge: motoLarge,
    imageMobile: motoMobile,
    value: dataForProducts[2].details.value,
    listPossibilities: dataForProducts[2].details.listPossibilities,
  },
  imovel: {
    imageSmall: imovelSmall,
    imageLarge: imovelLarge,
    imageMobile: imovelMobile,
    value: dataForProducts[3].details.value,
    listPossibilities: dataForProducts[3].details.listPossibilities,
  },
  pesados: {
    imageSmall: tratorSmall,
    imageLarge: tratorLarge,
    imageMobile: tratorMobile,
    value: dataForProducts[4].details.value,
    listPossibilities: dataForProducts[4].details.listPossibilities,
  },
  servico: {
    imageSmall: serviceSmall,
    imageLarge: serviceLarge,
    imageMobile: serviceMobile,
    value: dataForProducts[5].details.value,
    listPossibilities: dataForProducts[5].details.listPossibilities,
  },
  automovelAltoValor: {
    imageSmall: automovelAutoValorSmall,
    imageLarge: automovelAutoValor,
    imageMobile: automovelAutoValorMobile,
    value: dataForProducts[1].details.value,
    listPossibilities: dataForProducts[1].details.listPossibilities,
  },
  motoAltoValor: {
    imageSmall: motoAutoValorSmall,
    imageLarge: motoAutoValor,
    imageMobile: motoAutoValorMobile,
    value: dataForProducts[2].details.value,
    listPossibilities: dataForProducts[2].details.listPossibilities,
  },
} satisfies Record<string, IProductVisual>;

/** idComercial (retornado pela API) -> família visual local */
const familyByIdComercial: Record<number, keyof typeof visualByFamily> = {
  10: "automovel", // Automóveis
  20: "automovelAltoValor", // Automóveis de alto valor
  30: "moto", // Motos
  40: "motoAltoValor", // Motos de alto valor
  50: "imovel", // Imóveis
  60: "pesados", // Veículos Pesados
  70: "servico", // Serviço
};

export const getProductVisual = (
  idComercial?: number
): IProductVisual | undefined => {
  if (idComercial === undefined) return undefined;
  const family = familyByIdComercial[idComercial];
  return family ? visualByFamily[family] : undefined;
};

